module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-600.acb878a3.ttf";